import { NegotiationEventRequest } from '@interfaces/models/negotiation/negotiationEventRequest';
import { NegotiationRequest } from '@interfaces/models/negotiation/negotiationRequest';
import { Product } from '@interfaces/models/product';
import { Negotiation } from '@interfaces/models/negotiation/negotiation';
import { NegotiationsService } from '@services/negotiations-service';
import ProductService from '@services/product-service';

export class NegotiationsUtils {
  static async createNegotiation(
    productId: Product['id'],
    price: number,
    buyerId?: Negotiation['buyer']['id'],
    sellerCurrency?: string,
  ): Promise<Negotiation> {
    const requestParams: NegotiationRequest = {
      offerInWholeNumber: price,
    };

    if (buyerId) {
      requestParams.buyerId = buyerId;
    }

    if (buyerId && sellerCurrency) {
      requestParams.sellerCurrency = sellerCurrency;
    }

    try {
      return await ProductService.createNegotiation(productId, requestParams);
    } catch (e) {
      throw e?.response?.data?.errors?.detail || e;
    }
  }

  static addEvent = async (
    negotiationId: Negotiation['id'],
    action: NegotiationEventRequest['action'],
    price?: number,
  ): Promise<Negotiation> => {
    const event: NegotiationEventRequest = {
      action,
    };

    if (action === 'offer') {
      event.offerInWholeNumber = price;
    }

    const { data } = await NegotiationsService.addNegotiationEvent(negotiationId, event);
    return data;
  };

  static async sendOffer(negotiation: Negotiation, price: number): Promise<Negotiation> {
    return this.addEvent(negotiation.id, 'offer', price);
  }

  static async acceptOffer(negotiation: Negotiation): Promise<Negotiation> {
    return this.addEvent(negotiation.id, 'accept');
  }

  static async rejectOffer(negotiation: Negotiation): Promise<Negotiation> {
    return this.addEvent(negotiation.id, 'reject');
  }
}
